<picture>
	@for (source of resolvedSources; track $index) {
		<source
			[media]="source.media"
			[srcset]="
				image.src
					| imageQuery: { height: source.height, width: source.width }
			"
			type="image/jpeg"
		/>
	}
	<img
		[attr.alt]="image.altText || null"
		[attr.role]="!image.altText ? 'presentation' : null"
		[attr.style]="image.style"
		[attr.width]="imageWidth ? imageWidth : null"
		[class]="
			className +
			(isCustomImage ? '' : ' mx-auto w-full bg-ui-25 object-none')
		"
		[src]="
			image.src | imageQuery: { height: image.height, width: image.width }
		"
		(error)="setImageFallback()"
	/>
</picture>
